export const API_URL = {
  URL_LOCALE: "http://kaltbach/",
  URL_REMOTE: "https://www.emmi-kaltbach-win.ch/lenaxis/",
};
